<div class="d-flex-end alert-panel" *ngIf="showResumeWarning">
    <div class="cards">
        <i class="icon-spacing">
      <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
        <g id="ic-ok" transform="translate(0 -12)">
          <g id="ok" transform="translate(0 12)">
            <g id="Oval_55" data-name="Oval 55">
              <g id="Oval_55-2" data-name="Oval 55" fill="#004A63" stroke="#004A63" stroke-miterlimit="10"
                stroke-width="2">
                <circle cx="30" cy="30" r="30" stroke="none" />
                <circle cx="30" cy="30" r="29" fill="none" />
              </g>
              <circle id="Oval_55-3" data-name="Oval 55" cx="30" cy="30" r="30" fill="none" />
            </g>
            <path id="Path_3" data-name="Path 3" d="M0,10.672l6.621,6.4L24.178,0" transform="translate(18.622 21.889)"
              fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
              stroke-width="4" />
          </g>
        </g>
      </svg>
    </i>

        <h2 class="title">Welcome back</h2>
        <div class="alert-content">
            <p class="text-detail">
                Glad you are back. Now, continue where you left off in the account registration process.
            </p>
        </div>
        <button class="button-common button40 outline btn-spacing"  clickable (click)="resumeOnboarding()"><span>Continue</span></button>
    </div>
</div>